import { createSlice } from "@reduxjs/toolkit";
import { STATES_NAMES } from "../../enums/Enums";

const billingInitialState = {
  billingRules : [],
  validationHistoriesData: {
    validationHistories: [],
    validationAmountSum: 0,
    validationHistoriesCount: 0,
    minDate: null,
    maxDate: null
  }
}

const billingSlice = createSlice({
  name: STATES_NAMES.BILLING,
  initialState: billingInitialState,
  reducers: {
    setBillingRules(state, action) {
        state.billingRules = action.payload;
    },
    setValidationHistoriesData(state, action) {
      state.validationHistoriesData = { ...state.validationHistoriesData, ...action.payload};
    }
  }
});

export const billingActions = billingSlice.actions;

export default billingSlice.reducer;
